import React, {CSSProperties} from 'react';
import styled from 'styled-components';

const GlowOrb = styled.div`
  width: 100vmin;
  height: 100vmin;
  border-radius: 50%;
  z-index: -1;
  background: rgb(0, 234, 240);
  filter: blur(100px);
  opacity: 0.4;
  position: absolute;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-duration: 60s;
  animation-name: rotate;
  transform-origin: 25% 25%;

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
`;

function randomBetween(min: number, max: number) {
  return Math.random() * (max - min) + min;
}

const GradientMeshBackground: React.FC<{style?: CSSProperties}> = ({style}) => {
  function getRandomTransformOrigin() {
    return `${randomBetween(20, 30)}% ${randomBetween(20, 30)}%`;
  }

  const orbStyles: CSSProperties[] = [
    {
      top: `-40%`,
      left: `-30%`,
      animationDuration: `${randomBetween(40, 70)}s`,
      transformOrigin: getRandomTransformOrigin(),
    },
    {
      top: `90%`,
      left: `-30%`,
      animationDuration: `${randomBetween(40, 70)}s`,
      transformOrigin: getRandomTransformOrigin(),
    },
    {
      top: `90%`,
      right: `-50%`,
      animationDuration: `${randomBetween(40, 70)}s`,
      transformOrigin: getRandomTransformOrigin(),
    },
  ];
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -1,
        backgroundColor: '#0053c8',
        ...style,
      }}
    >
      {orbStyles.map((style, index) => (
        <GlowOrb style={style} key={index} />
      ))}
    </div>
  );
};

export default React.memo(GradientMeshBackground);
